import { Layer, View } from "@hscmap/stellar-globe";
import { LayerComponentBase } from '@/stellar-globe-components';
import { Component, Prop, Watch } from "vue-property-decorator";
import { AreaRenderer } from "./AreaRenderer";
import { V4 } from '@/utils/math';

type AreaType = [number, number, number][][]

class AreaLayer extends Layer {
  constructor(public area: AreaType, public color: V4) {
    super()
    this.refresh()
  }

  fr!: AreaRenderer
  onAdd() {
    this.fr = new AreaRenderer(this.globe, this.area, this.color)
  }

  onRemove() {
    this.fr.release()
  }

  render(view: View) {
    this.fr.alpha = Layer.overlayAlpha(view)
    this.fr.render(view)
  }

  refresh() {
    if (this.globe) {
      this.fr.color = this.color
      this.fr.area = this.area
      this.fr.refresh()
    }
  }
}

@Component
export default class AreaLayerComponent extends LayerComponentBase<AreaLayer> {
  @Prop({ required: true })
  area!: [number, number, number][][]
  @Watch('area')
  onRerunChange() {
    this.layer.area = this.area
    this.layer.refresh()
  }

  @Prop({ required: true })
  color!: V4
  @Watch('color')
  onColorChange() {
    this.layer.color = this.color
    this.layer.refresh()
  }

  newLayer() {
    return new AreaLayer(this.area, this.color)
  }
}
